import { toast } from 'react-toastify';
import { familyApi } from '../../../../services/family-api';
import { ModalBody, ModalFooter } from '../../../../components/Modal/styles';
import Button from '../../../../components/Button';
import { LoadingSpinner } from '../../../../components/Loading/styles';
import Modal from '../../../../components/Modal';
import { ModalProps } from '../OwnerPage/OwnerPage';
import { Actions, Categories } from '../../../../types/gtm';

const CancelModal = ({
  user,
  modal,
  loading,
  setModal,
  setLoading,
  close,
}: ModalProps) => {
  const label = 'Tela Cancelar Convite';
  const labelPost = 'Tela Convite Cancelado';

  async function cancel() {
    setLoading(true);

    window.dataLayer.push({
      event: 'customEventUserInteraction',
      event_category: Categories.FamilyOwner,
      event_action: Actions.ClickCancelInvite,
      event_label: label,
      bd_suser_code: user?.globoId,
    });

    await familyApi
      .delete('/v1/fe/user/granted/invite', {
        data: { iid: modal.inviteId },
      })
      .then(response => {
        window.dataLayer.push({
          event: 'customEventUserInteraction',
          event_category: Categories.FamilyOwner,
          event_action: Actions.Success,
          event_label: labelPost,
          bd_suser_code: user?.globoId,
        });

        setLoading(false);
        setModal({ ...modal, alreadyRequest: true });

        if (response.status !== 204) {
          toast.error('Ocorreu um erro ao cancelar o convite');
          close(false);
        }
      })
      .catch(() => {
        setLoading(false);
        toast.error('Ocorreu um erro ao cancelar o convite');
        close(false);
      });
  }

  return (
    <Modal header="Cancelar convite?">
      <ModalBody>
        {!modal.alreadyRequest ? (
          <>
            <p>
              Deseja cancelar o envio de convite para
              <b> {modal.email}</b>?
            </p>
            <p>
              Isso significa que essa pessoa não poderá mais entrar na sua
              família a não ser que seja convidada novamente.
            </p>
          </>
        ) : (
          <p>
            O convite enviado para <b>{modal.email}</b> foi cancelado com
            sucesso.
          </p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          variant="primary"
          onClick={() =>
            close(
              modal.alreadyRequest,
              modal.alreadyRequest ? labelPost : label,
            )
          }
        >
          Fechar
        </Button>
        {!modal.alreadyRequest && (
          <Button variant="secondary" onClick={() => cancel()}>
            {loading ? <LoadingSpinner isButton /> : 'Cancelar convite'}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default CancelModal;
